import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

/**
 * Guard tenant « par clé » — restreint une route à un ensemble de tenants.
 *
 * Complète tenantModuleGuard (basé sur l'activation d'un module) pour les
 * fonctionnalités SPÉCIFIQUES à un tenant, sans clé de module dédiée : ex.
 * HealthBoard (catégories) est propre à VGS alors que le module GPAnet reste
 * activé partout — moduleEnabled('GPAnet') ne suffit donc pas à isoler VGS.
 *
 * Défense en profondeur du menu (les entrées HealthBoard sont déjà gated
 * vgs-only côté menu) : bloque l'accès par URL directe hors des tenants
 * autorisés. Convention de refus calquée sur auth.guard.admin.ts :
 * Router.navigate(['/dashboard']) puis return false.
 */
export function tenantKeyGuard(allowedKeys: string[]): CanActivateFn {
  return () => {
    const tenant = inject(TenantService);
    const router = inject(Router);

    if (allowedKeys.indexOf(tenant.key) > -1) {
      return true;
    }

    router.navigate(['/dashboard']);
    return false;
  };
}
